const api = '/api/cApi.php';
import axios from 'axios';
export const cApiRepsitory =  {
    methods: {
        async post(item){
            return  axios.post(api,item)
        }
    }
};

